// Which dock tab a media dropdown's "Play in Dock" opens on. A song playing
// in radio mode (the inline station play from a tuner, or the song the dock's
// radio is airing) docks as the radio, following the station; anything else
// docks onto the playlist's now-playing view.
export function playInDockTab({
    mediaKey = null,
    radioFeature = false,
    radioOn = false,
    nowPlayingMediaKey = null,
    inlineRadio = false,
} = {}) {
    if (!mediaKey || !radioFeature) return 'playlist'
    if (inlineRadio && !radioOn) return 'radio'
    if (radioOn && nowPlayingMediaKey === mediaKey) return 'radio'
    return 'playlist'
}

export const PLAY_IN_DOCK_LABEL = 'Play in Dock'
